var _clipPath, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAltPropanol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7144"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7130"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7128"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L161 0 L161 101 L0 101 L0 0 Z",
    transform: "translate(0, 0)",
    id: "path10494"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M0,3.8L0,3.8L0,3.8L0,3.8L0,3.8z M434,224.2 M0,3.8"
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#840000",
      strokeWidth: 1.464,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.450777
    },
    id: "rect262",
    width: 103.02634,
    height: 118.93182,
    x: 1.3825192,
    y: 1.685971,
    ry: 7.1569595
  }), /*#__PURE__*/React.createElement("g", {
    id: "g14136",
    transform: "matrix(0.32471281,0,0,0.32471281,10.661664,49.971394)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 15,
      fontFamily: "Helvetica",
      stroke: "#000000",
      strokeWidth: 1.21583,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "g3013",
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-346.97604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line3015",
    d: "M 61.0126,137.5126 83.916534,124.28425",
    style: {
      strokeWidth: 1.21583,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 15,
      fontFamily: "Helvetica",
      stroke: "#000000",
      strokeWidth: 1.21583,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "g3017",
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-346.97604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line3019",
    d: "M 83.916534,124.28425 106.82047,137.5126",
    style: {
      strokeWidth: 1.21583,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 15,
      fontFamily: "Helvetica",
      stroke: "#000000",
      strokeWidth: 1.21583,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "g3021",
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-346.97604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line3023",
    d: "M 106.82047,137.5126 122,128.74554",
    style: {
      strokeWidth: 1.21583,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "text3025",
    style: {
      fontSize: 15,
      fontFamily: "helvetica",
      fill: "#000000",
      strokeLinecap: "round"
    },
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-339.70059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3037",
    style: {
      fontFamily: "helvetica",
      fill: "#000000"
    },
    d: "m 124.0251,122.05476 c 0,-1.78222 0.47852,-3.17749 1.43555,-4.18579 0.95703,-1.0083 2.19238,-1.51245 3.70605,-1.51246 0.99121,1e-5 1.88476,0.23683 2.68067,0.71045 0.79589,0.47365 1.40257,1.13405 1.82006,1.9812 0.41747,0.84718 0.62621,1.80787 0.62623,2.88208 -2e-5,1.08888 -0.21974,2.063 -0.65918,2.92237 -0.43947,0.85937 -1.06203,1.51001 -1.86768,1.9519 -0.80567,0.4419 -1.67481,0.66284 -2.60742,0.66284 -1.01075,0 -1.91407,-0.24414 -2.70996,-0.73242 -0.7959,-0.48828 -1.39893,-1.15478 -1.80908,-1.99951 -0.41016,-0.84472 -0.61524,-1.73828 -0.61524,-2.68066 z m 1.46484,0.022 c 0,1.29395 0.3479,2.31323 1.04371,3.05786 0.69579,0.74463 1.56859,1.11694 2.6184,1.11694 1.06933,0 1.94946,-0.37597 2.64038,-1.12793 0.69091,-0.75195 1.03637,-1.81884 1.03638,-3.20068 -1e-5,-0.87402 -0.14771,-1.63696 -0.44311,-2.28882 -0.29542,-0.65185 -0.72755,-1.15722 -1.29639,-1.51611 -0.56886,-0.35888 -1.20728,-0.53832 -1.91528,-0.53833 -1.00587,1e-5 -1.87135,0.34547 -2.59644,1.03638 -0.7251,0.69092 -1.08765,1.84448 -1.08765,3.46069 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3039",
    style: {
      fontFamily: "helvetica",
      fill: "#000000"
    },
    d: "m 136.16133,127.28425 v -10.73731 h 1.4209 v 4.40918 h 5.58105 v -4.40918 h 1.4209 v 10.73731 h -1.4209 v -5.06104 h -5.58105 v 5.06104 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 6.0510237,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.333333,
      paintOrder: "stroke markers fill"
    },
    d: "m 47.515802,264.22827 c -0.234959,-0.6123 0.01318,-1.51972 0.55142,-2.01649 1.374221,-1.26835 83.388338,-48.5629 84.250698,-48.5843 0.38813,-0.01 19.23386,10.69182 41.87939,23.781 26.30793,15.20607 41.57933,23.64286 42.29721,23.36738 0.61793,-0.23712 12.91737,-7.24593 27.33208,-15.57512 14.41471,-8.32919 26.70634,-15.14399 27.31473,-15.14399 0.60838,0 1.28965,0.47821 1.51394,1.06268 0.50626,1.3193 1.35438,0.78714 -30.89765,19.38698 -19.91786,11.48669 -26.31654,14.86642 -27.16928,14.3506 -9.65207,-5.83857 -81.66216,-47.03178 -82.21407,-47.03037 -0.41913,0.001 -19.26554,10.69236 -41.880922,23.75842 -22.615381,13.06606 -41.440956,23.75647 -41.83461,23.75647 -0.393655,0 -0.907976,-0.50097 -1.142936,-1.11326 z",
    id: "path18281",
    transform: "scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.27018,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.333333,
      paintOrder: "stroke markers fill"
    },
    d: "m 291.95577,234.73278 c -16.00293,-4.465 -17.93589,-29.89482 -2.82826,-37.2083 7.62797,-3.69264 17.9261,-0.99309 22.56493,5.91517 4.09899,6.1043 4.67435,14.4589 1.50339,21.83 -3.32112,7.72014 -12.62708,11.86625 -21.24006,9.46313 z m 13.14745,-5.60274 c 3.62182,-2.7625 4.88368,-5.61058 5.25444,-11.85957 0.69666,-11.74169 -4.50289,-18.05597 -14.35193,-17.42883 -8.25413,0.52558 -12.4199,5.88204 -12.46419,16.02678 -0.0258,5.89981 1.32127,9.65115 4.49,12.50414 3.01751,2.71685 4.36994,3.13438 9.48471,2.92824 4.21242,-0.16977 5.41444,-0.51369 7.58697,-2.17076 z",
    id: "path18283",
    transform: "scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 4.27018,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.333333,
      paintOrder: "stroke markers fill"
    },
    d: "m 322.50287,215.58999 v -19.40662 h 2.46994 2.46993 v 8.1155 8.11549 h 10.58543 10.58544 v -8.11549 -8.1155 h 2.11708 2.11709 v 19.40662 19.40663 h -2.11709 -2.11708 v -9.17404 -9.17404 h -10.58544 -10.58543 v 9.17404 9.17404 h -2.46993 -2.46994 z",
    id: "path18285",
    transform: "scale(0.26458333)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltPropanol);
export default __webpack_public_path__ + "static/media/altPropanol.47f833e0cf964a0f4d83f42753db2250.svg";
export { ForwardRef as ReactComponent };